<template>
  <div class="page-container">
    <main class="main-content">
      <div class="page-inner-box">
        <el-card class="banner" shadow="never">
          <div class="banner-title" v-if="bizType === 'course'">支付完成就可以去学习了噢～</div>
          <div class="order-info">
            <img v-if="course.image" :src="course.image" alt="封面" class="course-cover" style="width: 100px; height: 75px; object-fit: cover; margin-right: 15px; border-radius: 4px;" />
            <div class="info-text">
              <div class="row"><span>名称：</span><span class="name">{{ course.title }}</span></div>
              <div class="row"><span>价格：</span><span class="price">¥{{ price }}</span></div>
            </div>
          </div>
        </el-card>

        <el-card class="pay-card" shadow="never">
          <div class="methods">
            <div class="label">支付方式</div>
            <div class="btns">
              <div class="pay-btn" :class="{ active: payMethod==='wechat' }" @click="payMethod='wechat'">
                <img src="@/assets/image/weixin.png" alt="微信支付" class="pay-icon">
                微信支付
              </div>
              <div class="pay-btn" :class="{ active: payMethod==='alipay' }" @click="payMethod='alipay'">
                <img src="@/assets/image/zhifubao.png" alt="支付宝支付" class="pay-icon">
                支付宝支付
              </div>
            </div>
          </div>

          <div class="prefer">
            <div class="row">
              <span>金币抵扣</span>
              <div class="coin-right">
                <span v-if="!isLoggedIn" class="no-available">登录后可使用</span>
                <span v-else-if="goldCount <= 0" class="no-available">无可用金币</span>
                <div v-else class="coin-input">
                  <span class="coin-available">可用 {{ goldCount }}</span>
                  <el-input-number
                    v-model="orderForm.coinAmount"
                    size="mini"
                    :min="0"
                    :max="maxCoinToUse"
                    :precision="2"
                    :step="0.1"
                    controls-position="right"
                    @change="onCoinAmountChange"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="qr-wrap">
            <div class="qr-box" v-loading="requestingPayUrl" element-loading-text="加载中...">
              <img v-if="qrCodeDataUrl && !requestingPayUrl" :src="qrCodeDataUrl" alt="支付二维码" class="qr-img" />
              <div v-else-if="!requestingPayUrl" class="qr-placeholder">
                {{ orderNo ? '暂无支付二维码，请点击重新获取' : '创建订单后生成二维码' }}
              </div>
            </div>
            <div v-if="qrCodeDataUrl && !requestingPayUrl" class="qr-tip">请用{{ payMethod==='wechat' ? '微信' : '支付宝' }}扫码，支付 <span class="price">¥{{ price }}</span></div>
            <div v-else-if="requestingPayUrl" class="qr-tip">正在获取支付二维码...</div>
            <div v-else class="qr-tip">
               {{ orderNo ? '点击下方按钮获取支付信息' : (creatingOrder ? '正在创建订单...' : '订单创建失败，请重试') }}
            </div>
            <div v-if="zeroAmountOrder && orderNo" class="zero-amount-confirm">
              <p class="zero-tip">优惠券已抵扣全部金额，无需支付</p>
              <el-button type="primary" size="medium" :loading="confirmingZeroOrder" @click="confirmZeroAmountOrder">确认下单</el-button>
            </div>
<!--            <el-button-->
<!--              v-if="orderNo && !qrCodeDataUrl"-->
<!--              type="primary"-->
<!--              size="small"-->
<!--              :loading="requestingPayUrl"-->
<!--              @click="requestPayUrl"-->
<!--            >-->
<!--              重新获取支付二维码-->
<!--            </el-button>-->
<!--            <el-button-->
<!--              v-else-if="!orderNo && autoCreateFailed"-->
<!--              type="primary"-->
<!--              size="small"-->
<!--              :loading="creatingOrder || requestingPayUrl"-->
<!--              @click="createOrderAndPay"-->
<!--            >-->
<!--              重新创建订单-->
<!--            </el-button>-->

          </div>
        </el-card>
      </div>
    </main>

    <!-- 购买成功弹框 -->
    <el-dialog
      title=""
      :visible.sync="showSuccessDialog"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      custom-class="success-dialog"
      center
    >
      <div class="success-content">
        <div class="success-icon-wrap">
          <img :src="require('@/assets/image/caozuochenggong.png')" class="success-main-img" alt="操作成功" />
          <img :src="require('@/assets/image/icon_right.png')" class="success-check-icon" alt="成功" />
        </div>
        <div class="success-text">
          <div class="title">操作成功</div>
          <div class="desc">{{ bizType === 'paper' ? '试卷购买成功，可以去答题了哦！' : bizType === 'class' ? '班级购买成功，可以去学习了哦！' : '课程购买成功，可以去学习了哦！' }}</div>
        </div>
        <el-button type="primary" class="confirm-btn" @click="onConfirmSuccess">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { alipayCallback, createCourseOrder, createPaperOrder, createClassOrder, payOrder, wechatCallback, getOrderPaymentStatus } from '@/api/orderApi'
import { getCourseDetail } from '@/api/courseApi'
import { getPaperDetail } from '@/api/examApi'
import { getClassDetail } from '@/api/classApi'
import { getMallProductDetail } from '@/api/mallApi'
import { getMyCoupons, getPersonalOverview } from '@/api/authApi'
import QRCode from 'qrcode'

export default {
  name: 'CoursePayment',
  data() {
    return {
      courseId: null,
      bizType: 'course',
      orderNo: null,
      payUrl: '',
      qrCodeDataUrl: '', // 二维码图片的 base64 数据
      course: { title: '课程', price: 1000 },
      payMethod: 'wechat',
      showSuccessDialog: false, // 购买成功弹框状态
      zeroAmountOrder: false, // 0元订单待确认
      confirmingZeroOrder: false, // 0元订单确认中
      pollingTimer: null, // 支付轮询定时器
      checkoutItems: [], // 从购物车选中的商品
      totalAmount: 0, // 总支付金额
      handledPayCallback: false,
      requestingPayUrl: false,
      creatingOrder: false,
      autoCreateFailed: false,
      couponsLoading: false,
      coupons: [],
      selectedCouponId: null,
      goldCount: 0,
      goldLoading: false,
      originTotalAmount: 0,
      orderForm: {
        cashAmount: null,
        coinAmount: 0,
        couponAmount: null,
        couponId: null,
        payType: null
      },
      courseLoading: false
    }
  },
  created() {
    this.init()
  },
    beforeDestroy() {
      this.stopPaymentPolling()
    },
    watch: {
      '$route.params.id': 'init',
      payMethod() {
        // 切换支付方式时，先清空旧的支付URL和二维码
        this.payUrl = ''
        this.qrCodeDataUrl = ''
        if (this.orderNo && Number(this.totalAmount || 0) > 0) {
          this.requestPayUrl()
        }
      },
      isLoggedIn(next) {
        if (next) {
          this.loadGoldCount()
          this.loadAvailableCoupons()
        } else {
          this.goldCount = 0
          this.orderForm.coinAmount = 0
          this.orderForm.couponId = null
          this.orderForm.couponAmount = null
          this.selectedCouponId = null
        }
      }
    },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    price() {
      return this.totalAmount.toFixed(2)
    },
    qrUrl() {
      return this.qrCodeDataUrl
    },
    availableCoupons() {
      return Array.isArray(this.coupons) ? this.coupons : []
    },
    maxCoinToUse() {
      const owned = Number(this.goldCount || 0)
      const base = Number(this.originTotalAmount || 0)
      const cap = Math.max(0, Math.min(owned, base))
      return Number.isFinite(cap) ? cap : 0
    }
  },
  methods: {
    getOrderStorageKeys() {
      if (this.bizType === 'paper') return { orderNoKey: 'orderNo_paper', orderBizIdKey: 'orderPaperId' }
      if (this.bizType === 'product') return { orderNoKey: 'orderNo_product', orderBizIdKey: 'orderProductId' }
      if (this.bizType === 'class') return { orderNoKey: 'orderNo_class', orderBizIdKey: 'orderClassId' }
      return { orderNoKey: 'orderNo', orderBizIdKey: 'orderCourseId' }
    },
    async init() {
      const id = this.$route.params.id
      this.courseId = id
      if (this.$route.query && this.$route.query.bizType) {
        this.bizType = this.$route.query.bizType
      }
      const { orderNoKey, orderBizIdKey } = this.getOrderStorageKeys()
      const queryOrderNo = this.$route && this.$route.query && this.$route.query.orderNo
      const forceCreateRaw = this.$route && this.$route.query && this.$route.query.forceCreate
      const forceCreate = String(forceCreateRaw || '').toLowerCase()
      const shouldForceCreate = forceCreate === '1' || forceCreate === 'true' || forceCreate === 'yes'
      const storedOrderNo = localStorage.getItem(orderNoKey)
      const storedCourseId = localStorage.getItem(orderBizIdKey)

      if (queryOrderNo) {
        this.orderNo = queryOrderNo
        try {
          localStorage.setItem(orderNoKey, String(queryOrderNo))
          localStorage.setItem(orderBizIdKey, String(id || ''))
        } catch (e) {
          void e
        }
      } else if (storedOrderNo && storedCourseId != null && String(storedCourseId) === String(id)) {
        this.orderNo = storedOrderNo
      } else {
        this.orderNo = null
      }

      if (!queryOrderNo && storedCourseId != null && String(storedCourseId) !== String(id)) {
        try {
          localStorage.removeItem(orderNoKey)
          localStorage.removeItem(orderBizIdKey)
        } catch (e) {
          void e
        }
      }
      if (!queryOrderNo && shouldForceCreate) {
        try {
          localStorage.removeItem(orderNoKey)
          localStorage.removeItem(orderBizIdKey)
        } catch (e) {
          void e
        }
        this.orderNo = null
      }
      this.payUrl = ''
      this.qrCodeDataUrl = ''
      this.checkoutItems = []
      this.totalAmount = 0
      this.originTotalAmount = 0
      this.autoCreateFailed = false
      
      const applied = this.applyCheckoutFromRoute()
      if (!applied) this.getCheckoutItems()
      this.applyOrderFormFromRoute()
      await this.ensureCourseLoaded()
      this.originTotalAmount = Number(this.totalAmount || 0)
      await this.loadAvailableCoupons()
      await this.loadGoldCount()

      this.handlePaymentCallbackFromRoute()
      if (!this.orderNo && !this.handledPayCallback) {
        await this.createOrderAndPay()
        this.autoCreateFailed = !this.orderNo
      } else if (this.orderNo) {
        if (Number(this.totalAmount || 0) === 0) {
          this.showSuccessDialog = true
        } else {
          this.requestPayUrl()
        }
      }
      
      this.startPaymentPolling()
    },
    startPaymentPolling() {
      this.stopPaymentPolling()
      if (Number(this.totalAmount || 0) === 0) return
      if (!this.orderNo) return
      
      this.pollingTimer = setInterval(async () => {
        try {
          const res = await getOrderPaymentStatus(this.orderNo)
          const data = res && res.data ? res.data : null
          if (data && (data.payStatus === 1 || data.payStatus === '1' || data.payStatus === true)) {
            this.stopPaymentPolling()
            this.$message.success('支付成功')
            if (this.bizType === 'class') {
              this.$router.push({ name: 'classStudyDetail', params: { id: this.courseId } })
            } else {
              this.$router.push({ name: 'myOrders' })
            }
          }
        } catch (e) {
          // ignore polling errors
        }
      }, 1000)
    },
    stopPaymentPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer)
        this.pollingTimer = null
      }
    },
    toNumber(val) {
      if (val == null || val === '') return null
      const n = Number(val)
      return Number.isFinite(n) ? n : null
    },
    applyOrderFormFromRoute() {
      const query = this.$route && this.$route.query ? this.$route.query : {}
      const cashAmount = this.toNumber(query.cashAmount)
      const coinAmount = this.toNumber(query.coinAmount)
      const couponAmount = this.toNumber(query.couponAmount)
      const couponId = this.toNumber(query.couponId)
      const payType = this.toNumber(query.payType)

      this.orderForm = {
        cashAmount,
        coinAmount: coinAmount == null ? 0 : coinAmount,
        couponAmount,
        couponId,
        payType
      }
      this.selectedCouponId = couponId

      if (payType === 1) {
        this.payMethod = 'wechat'
      } else if (payType === 2) {
        this.payMethod = 'alipay'
      }
    },
    couponValue(c) {
      const id = c && (c.couponId ?? c.id)
      const n = Number(id)
      if (Number.isFinite(n)) return n
      if (id == null || id === '') return ''
      return String(id)
    },
    couponLabel(c) {
      const couponName = String((c && c.couponName) || '')
      const discountAmount = Number((c && c.discountAmount) || 0)
      const minAmount = Number((c && c.minAmount) || 0)
      const expire = String((c && c.expireTime) || '')
      
      // 构建显示文本：优惠券名称 - 优惠金额
      let label = couponName || '优惠券'
      if (discountAmount > 0) {
        label += ` -¥${discountAmount.toFixed(2)}`
      }
      if (minAmount > 0) {
        label += ` (满${minAmount}可用)`
      }
      return label
    },
    async loadAvailableCoupons() {
      if (!this.isLoggedIn) {
        this.coupons = []
        this.couponsLoading = false
        return
      }
      if (this.couponsLoading) return
      this.couponsLoading = true
      try {
        const res = await getMyCoupons({ status: 0 })
        const data = res && res.data
        const list = Array.isArray(data) ? data : []
        
        const now = new Date().getTime()
        this.coupons = list.filter(coupon => {
          const expireTime = coupon && coupon.expireTime
          if (!expireTime) return true
          const expireDate = new Date(expireTime).getTime()
          return expireDate > now
        })
        
        const picked = this.toNumber(this.selectedCouponId)
        if (picked != null) {
          const exists = list.some(it => this.couponValue(it) === picked)
          if (!exists) {
            this.selectedCouponId = null
            this.orderForm.couponId = null
          }
        }
      } catch (e) {
        this.coupons = []
      } finally {
        this.couponsLoading = false
      }
    },
    async loadGoldCount() {
      if (!this.isLoggedIn) {
        this.goldCount = 0
        return
      }
      if (this.goldLoading) return
      this.goldLoading = true
      try {
        const res = await getPersonalOverview()
        const data = (res && res.data) || {}
        const goldCount = data.goldCount == null ? 0 : Number(data.goldCount)
        this.goldCount = Number.isFinite(goldCount) ? goldCount : 0
      } catch (e) {
        this.goldCount = 0
      } finally {
        this.goldLoading = false
      }
    },
    normalizeCoinAmount(val) {
      const n = this.toNumber(val)
      if (n == null) return 0
      const bounded = Math.max(0, Math.min(n, this.maxCoinToUse))
      return Number.isFinite(bounded) ? bounded : 0
    },
    async onCoinAmountChange(val) {
      const next = this.normalizeCoinAmount(val)
      if (Number(next) !== Number(val)) {
        this.orderForm.coinAmount = next
        if (Number(val || 0) > this.maxCoinToUse) this.$message.warning('核销金币不能超过所拥有的金币数量')
      }
      this.orderForm.coinAmount = next

      if (this.creatingOrder || this.requestingPayUrl) return
      if (!this.courseId) return

      this.stopPaymentPolling()
      this.orderNo = null
      this.payUrl = ''
      this.qrCodeDataUrl = ''
      this.totalAmount = Number(this.originTotalAmount || 0)
      try {
        const { orderNoKey, orderBizIdKey } = this.getOrderStorageKeys()
        localStorage.removeItem(orderNoKey)
        localStorage.removeItem(orderBizIdKey)
      } catch (e) {
        void e
      }
      await this.createOrderAndPay()
      this.startPaymentPolling()
      this.startPaymentPolling()
    },
    async onCouponChange(val) {
      const id = this.toNumber(val)
      this.orderForm.couponId = id
      
      // 根据选中的优惠券计算优惠金额
      if (id != null) {
        const selectedCoupon = this.coupons.find(c => this.couponValue(c) === id)
        if (selectedCoupon) {
          const discountAmount = Number(selectedCoupon.discountAmount || 0)
          this.orderForm.couponAmount = discountAmount > 0 ? discountAmount : null
        } else {
          this.orderForm.couponAmount = null
        }
      } else {
        this.orderForm.couponAmount = null
      }

      if (this.creatingOrder || this.requestingPayUrl) return
      if (!this.courseId) return

      this.stopPaymentPolling()
      this.orderNo = null
      this.payUrl = ''
      this.qrCodeDataUrl = ''
      this.totalAmount = Number(this.originTotalAmount || 0)
      try {
        const { orderNoKey, orderBizIdKey } = this.getOrderStorageKeys()
        localStorage.removeItem(orderNoKey)
        localStorage.removeItem(orderBizIdKey)
      } catch (e) {
        void e
      }
      await this.createOrderAndPay()
      this.startPaymentPolling()
    },
    applyCheckoutFromRoute() {
      const query = this.$route && this.$route.query ? this.$route.query : {}

      const title = String(query.title || query.courseTitle || query.name || '').trim()
      const image = this.sanitizeUrl(query.image || query.coverImage || query.img)
      const quantityRaw = this.toNumber(query.quantity || query.qty || query.count)
      const priceRaw = this.toNumber(query.price || query.unitPrice)
      const totalAmountRaw = this.toNumber(query.totalAmount || query.amount || query.total)

      const hasAny =
        Boolean(title) ||
        Boolean(image) ||
        quantityRaw != null ||
        priceRaw != null ||
        totalAmountRaw != null
      if (!hasAny) return false

      const quantity = quantityRaw != null && quantityRaw > 0 ? Math.floor(quantityRaw) : 1
      let price = priceRaw
      let totalAmount = totalAmountRaw

      if (totalAmount == null && price != null) totalAmount = Number(price) * quantity
      if (price == null && totalAmount != null) price = quantity ? Number(totalAmount) / quantity : Number(totalAmount)

      const item = {
        id: this.courseId,
        title: title || (this.bizType === 'paper' ? '试卷' : '课程'),
        image,
        price: price != null ? Number(price) : 0,
        quantity
      }

      this.checkoutItems = [item]
      this.course = { title: item.title, price: item.price }
      if (totalAmount != null) this.totalAmount = Number(totalAmount) || 0

      if (price != null || totalAmount != null) {
        try {
          localStorage.setItem('checkoutItems', JSON.stringify(this.checkoutItems))
          localStorage.setItem('totalAmount', String(this.totalAmount))
        } catch (e) {
          void e
        }
      }

      return true
    },
    sanitizeUrl(val) {
      const s = String(val || '').trim()
      if (!s) return ''
      return s.replace(/`/g, '').trim()
    },
    async ensureCourseLoaded() {
      if (this.courseLoading) return
      if (this.checkoutItems && this.checkoutItems.length > 0) return
      const id = this.courseId
      if (!id) return

      this.courseLoading = true
      try {
        let title = '课程'
        let amount = 0
        let image = ''

        if (this.bizType === 'product') {
           const res = await getMallProductDetail(id)
           const data = res && res.data ? res.data : null
           if (data) {
             amount = Number(data.price || 0)
             title = String(data.productName || '商品')
             image = data.productImage || ''
           }
        } else if (this.bizType === 'paper') {
          const res = await getPaperDetail(id)
          const data = res && res.data ? res.data : null
          if (data) {
            amount = Number(data.price || 0)
            title = String(data.paperName || '试卷')
            image = data.coverImage || ''
          } else {
            title = '试卷'
          }
        } else if (this.bizType === 'class') {
          const res = await getClassDetail(id)
          const data = res && res.data ? res.data : null
          if (data) {
            amount = Number(data.price || 0)
            title = String(data.className || '班级')
            image = data.coverImage || ''
          } else {
            title = '班级'
          }
        } else {
           const res = await getCourseDetail(id)
           const data = res && res.data ? res.data : null
           if (data) {
             const currentPrice =
               data.discountPrice != null
                 ? data.discountPrice
                 : (data.currentPrice != null ? data.currentPrice : (data.salePrice != null ? data.salePrice : 0))
             amount = Number(currentPrice || 0)
             title = String(data.courseName || '课程')
             image = data.courseImage || ''
           }
        }

        this.course = {
          title: title,
          price: amount,
          image: image
        }
        this.totalAmount = amount
        this.originTotalAmount = amount
      } catch (err) {
        this.$message.error((err && err.message) || '获取详情失败')
      } finally {
        this.courseLoading = false
      }
    },
    buildCreateOrderPayload() {
      const courseId = Number(this.courseId)
      const baseAmount = Number(this.originTotalAmount || this.totalAmount || 0)
      const coinAmount = this.normalizeCoinAmount(this.orderForm.coinAmount)
      const couponAmount = Number(this.orderForm.couponAmount || 0)
      const couponId = this.orderForm.couponId != null ? Number(this.orderForm.couponId) : null
      const cashAmount = Math.max(0, baseAmount - coinAmount - couponAmount)

      let payType = this.orderForm.payType != null ? Number(this.orderForm.payType) : null
          if (payType == null) {
            if (coinAmount > 0 || couponAmount > 0 || couponId) {
              payType = 6
            } else {
              payType = this.payMethod === 'alipay' ? 2 : 1
            }
          }

          const distributorId = this.$route.query.distributorId

          return {
            cashAmount,
            coinAmount,
            couponAmount,
            couponId,
            ...(this.bizType === 'paper' ? { paperId: courseId } : this.bizType === 'class' ? { classId: courseId } : { courseId }),
            payType,
            ...(distributorId ? { distributorId } : {})
          }
        },
    async createOrderAndPay() {
      if (this.creatingOrder) return
      const payload = this.buildCreateOrderPayload()
      
      // 保存实际支付金额（扣除优惠券和金币后的金额）
      const actualPayAmount = payload.cashAmount || 0
      
      if (this.bizType === 'paper') {
        if (!payload.paperId) {
          this.$message.error('试卷ID无效')
          return
        }
      } else if (this.bizType === 'class') {
        if (!payload.classId) {
          this.$message.error('班级ID无效')
          return
        }
      } else if (!payload.courseId) {
        this.$message.error('课程ID无效')
        return
      }

      this.creatingOrder = true
      try {
        this.payUrl = ''
        this.qrCodeDataUrl = ''
        let res
        if (this.bizType === 'paper') {
          res = await createPaperOrder(payload)
        } else if (this.bizType === 'class') {
          res = await createClassOrder(payload)
        } else {
          res = await createCourseOrder(payload)
        }
        const data = res && res.data != null ? res.data : null
        
        let orderNo = null
        if (data && typeof data === 'object') {
          orderNo = data.orderNo || data.order_no || data.outTradeNo || data.out_trade_no || data.orderId || data.id
        } else if (typeof data === 'string') {
          orderNo = data
        }

        if (orderNo == null || orderNo === '') {
          this.$message.error('创建订单失败')
          return
        }

        this.orderNo = String(orderNo)
        const { orderNoKey, orderBizIdKey } = this.getOrderStorageKeys()
        localStorage.setItem(orderNoKey, this.orderNo)
        localStorage.setItem(orderBizIdKey, String(this.courseId || ''))

        // 使用后端返回的 payAmount，如果没有则使用前端计算的实际支付金额
        const payAmount = data && typeof data === 'object' ? data.payAmount : null
        if (payAmount != null) {
          this.totalAmount = Number(payAmount) || this.totalAmount
        } else {
          // 使用前端计算的扣除优惠券和金币后的金额
          this.totalAmount = Number(actualPayAmount) || this.totalAmount
        }

        if (Number(this.totalAmount || 0) === 0) {
          // 0元订单，后端已自动完成，直接查询状态确认
          const statusRes = await getOrderPaymentStatus(this.orderNo)
          const statusData = statusRes && statusRes.data
          if (statusData && (statusData.payStatus === 1 || statusData.orderStatus === 1)) {
            this.showSuccessDialog = true
          } else {
            this.zeroAmountOrder = true
          }
          return
        }

        // 提取支付URL，优先从 paymentParams 中获取
        let payUrl = ''
        if (data && typeof data === 'object') {
          if (data.paymentParams) {
            payUrl = data.paymentParams.codeUrl || data.paymentParams.paymentUrl || data.paymentParams.qrUrl || ''
          }
          if (!payUrl) {
            payUrl = data.payUrl || data.qrUrl || data.url || ''
          }
        }
        if (payUrl) {
          this.payUrl = String(payUrl)
          await this.generateQRCode(this.payUrl)
          return
        }

        await this.requestPayUrl()
      } catch (err) {
        if (err.response && err.response.status === 401) {
          this.$message.error('未授权，请先登录')
          this.$router.push('/login')
        } else {
          this.$message.error((err && err.message) || '创建订单失败')
        }
      } finally {
        this.creatingOrder = false
      }
    },
    async requestPayUrl() {
      if (this.requestingPayUrl) return
      const orderNo = String(this.orderNo || '').trim()
      if (!orderNo) return
      if (Number(this.totalAmount || 0) === 0) {
        this.showSuccessDialog = true
        return
      }

      const paymentType = this.payMethod === 'alipay' ? 2 : 1
      try {
        this.requestingPayUrl = true
        // 清空旧的支付URL和二维码，避免显示错误内容
        this.payUrl = ''
        this.qrCodeDataUrl = ''
        const res = await payOrder({ orderNo, paymentType })
        const data = res && res.data != null ? res.data : null
        
        let nextPayUrl = ''
        if (typeof data === 'string') {
          nextPayUrl = data
        } else if (data && typeof data === 'object') {
          // 优先从 paymentParams 中获取支付URL
          if (data.paymentParams) {
            // 微信支付返回的是 codeUrl，支付宝可能是 paymentUrl
            nextPayUrl = data.paymentParams.codeUrl || data.paymentParams.paymentUrl || data.paymentParams.qrUrl || ''
          }
          // 如果没有从 paymentParams 获取到，尝试其他字段
          if (!nextPayUrl) {
            const paymentForm = data.paymentForm || data.payForm || ''
            nextPayUrl = data.payUrl || data.qrUrl || data.url || this.buildPayUrlFromPaymentForm(paymentForm) || ''
          }
        }

        if (!nextPayUrl) {
          this.$message.error('发起支付失败')
          return
        }
        this.payUrl = String(nextPayUrl).trim()
        
        // 生成二维码
        await this.generateQRCode(this.payUrl)
        
        // Start polling when payUrl is successfully retrieved
        this.startPaymentPolling()
      } catch (err) {
        this.$message.error((err && err.message) || '发起支付失败')
      } finally {
        this.requestingPayUrl = false
      }
    },
    sanitizePaymentFormHtml(html) {
      return String(html || '').replace(/`/g, '').trim()
    },
    sanitizeGatewayUrl(url) {
      return String(url || '').replace(/`/g, '').replace(/\\+$/g, '').trim()
    },
    buildPayUrlFromPaymentForm(paymentFormHtml) {
      const raw = this.sanitizePaymentFormHtml(paymentFormHtml)
      if (!raw) return ''
      if (typeof window === 'undefined' || typeof DOMParser === 'undefined') return ''

      try {
        const parser = new DOMParser()
        const doc = parser.parseFromString(raw, 'text/html')
        const form = doc.querySelector('form')
        if (!form) return ''

        const action = this.sanitizeGatewayUrl(form.getAttribute('action') || '')
        if (!action) return ''

        const url = new URL(action, window.location.origin)
        const inputs = Array.from(form.querySelectorAll('input[name]'))
        inputs.forEach(input => {
          const name = input.getAttribute('name')
          if (!name) return
          const value = input.value != null ? String(input.value) : String(input.getAttribute('value') || '')
          url.searchParams.set(name, value)
        })
        return url.toString()
      } catch (e) {
        return ''
      }
    },
    async handlePaymentCallbackFromRoute() {
      if (this.handledPayCallback) return

      const query = this.$route && this.$route.query ? this.$route.query : {}

      const rawChannel = String(query.channel || query.payChannel || query.payMethod || query.method || '').toLowerCase()
      let channel = ''
      if (rawChannel === 'alipay' || rawChannel === 'ali') channel = 'alipay'
      if (rawChannel === 'wechat' || rawChannel === 'weixin' || rawChannel === 'wx') channel = 'wechat'
      if (!channel) {
        if (query.alipay != null) channel = 'alipay'
        if (query.wechat != null || query.wx != null) channel = 'wechat'
      }
      if (!channel) return

      const flag = String(query.callback || query.payCallback || query._callback || '').toLowerCase()
      const hasExplicitFlag = flag === '1' || flag === 'true' || flag === 'yes'

      const reservedKeys = new Set([
        'channel',
        'payChannel',
        'payMethod',
        'method',
        'callback',
        'payCallback',
        '_callback'
      ])

      const payload = Object.keys(query).reduce((acc, key) => {
        if (!reservedKeys.has(key)) acc[key] = query[key]
        return acc
      }, {})

      const payloadKeys = Object.keys(payload)
      if (!payloadKeys.length) return

      const knownKeys = new Set([
        'trade_no',
        'out_trade_no',
        'total_amount',
        'seller_id',
        'app_id',
        'sign',
        'sign_type',
        'appid',
        'mch_id',
        'nonce_str',
        'transaction_id',
        'result_code'
      ])
      const hasKnownKey = payloadKeys.some(k => knownKeys.has(k))
      if (!hasExplicitFlag && !hasKnownKey) return

      try {
        this.handledPayCallback = true
        if (channel === 'alipay') await alipayCallback(payload)
        if (channel === 'wechat') await wechatCallback(payload)
        this.paymentSuccess()
      } catch (err) {
        this.$message.error((err && err.message) || '支付回调处理失败')
      }
    },
    // 从localStorage获取购物车选中的商品和总金额
    getCheckoutItems() {
      // 获取选中的商品
      const checkoutItemsJson = localStorage.getItem('checkoutItems')
      if (checkoutItemsJson) {
        try {
          const parsed = JSON.parse(checkoutItemsJson)
          if (Array.isArray(parsed)) this.checkoutItems = parsed
        } catch (e) {
          this.checkoutItems = []
        }
      }
      
      // 获取总金额
      const totalAmountStr = localStorage.getItem('totalAmount')
      if (totalAmountStr) {
        const n = parseFloat(totalAmountStr)
        if (Number.isFinite(n)) this.totalAmount = n
      } else {
        // 如果没有总金额，重新计算
        this.totalAmount = this.checkoutItems.reduce((total, item) => {
          const price = Number(item && item.price) || 0
          const quantity = Number(item && item.quantity) || 0
          return total + price * quantity
        }, 0)
      }
      
      // 更新课程信息为第一个商品的信息
      if (this.checkoutItems.length > 0) {
        this.course = {
          title: this.checkoutItems[0] && this.checkoutItems[0].title,
          price: this.checkoutItems[0] && this.checkoutItems[0].price
        }
      }
    },
    // 生成二维码
    async generateQRCode(url) {
      const data = String(url || '').trim()
      if (!data) {
        this.qrCodeDataUrl = ''
        return
      }
      
      try {
        // 使用 qrcode 库生成二维码，返回 base64 格式的图片
        const qrCodeDataUrl = await QRCode.toDataURL(data, {
          width: 200,
          margin: 2,
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          }
        })
        this.qrCodeDataUrl = qrCodeDataUrl
      } catch (err) {
        console.error('生成二维码失败:', err)
        this.qrCodeDataUrl = ''
        // 如果生成失败，可以回退到在线服务
        this.qrCodeDataUrl = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(data)}`
      }
    },
    async confirmZeroAmountOrder() {
      if (this.confirmingZeroOrder) return
      this.confirmingZeroOrder = true
      try {
        // 验证订单状态
        const res = await getOrderPaymentStatus(this.orderNo)
        const data = res && res.data
        if (data && (data.payStatus === 1 || data.orderStatus === 1)) {
          this.zeroAmountOrder = false
          this.showSuccessDialog = true
        } else {
          // 订单未完成，可能需要后端处理0元订单
          this.$message.warning('订单处理中，请稍后...')
        }
      } catch (e) {
        this.$message.error('确认订单失败，请重试')
      } finally {
        this.confirmingZeroOrder = false
      }
    },
    // 确认支付成功
    onConfirmSuccess() {
      // 关闭弹框
      this.showSuccessDialog = false
      // 跳转到对应的页面
      if (this.bizType === 'class') {
        this.$router.push({ name: 'classStudyDetail', params: { id: this.courseId } })
      } else {
        this.$router.push('/member-center/courses')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.page-container { min-height: 100vh; display: flex; flex-direction: column; }
.main-content { flex: 1; padding-top: 20px; }

.banner { background: #4f46e5; color: #fff; }
.banner-title { font-size: 18px; font-weight: 600; padding: 12px 16px; }
.order-info { display: flex; gap: 20px; padding: 10px 16px; }
.order-info .name { color: #fff; }
.order-info .price { color: #ff4d4f; font-weight: 700; }

.pay-card { margin-top: 12px; }
.methods { margin-top: 16px; margin-bottom: 16px; }
.methods .label { font-weight: 600; margin-bottom: 12px; display: block; }
.btns { display: flex; gap: 16px; }

.pay-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 20px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
  background-color: white;
}

.pay-btn.active {
  border-color: #3E2CCD;
  background-color: #F5F3FF;
  color: #3E2CCD;
}

.pay-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.prefer { border-top: 1px solid #e4e7ed; padding-top: 16px; margin-top: 16px; display: flex; flex-direction: column; gap: 10px; }
.prefer .row { display: flex; justify-content: space-between; color: #606266; font-size: 14px; }
.prefer .no-available { color: #ff4d4f; }
.coupon-select { width: 350px; }
.coin-right { display: flex; align-items: center; justify-content: flex-end; flex: 1; }
.coin-input { display: flex; align-items: center; gap: 10px; }
.coin-available { color: #606266; }

.qr-wrap { margin-top: 24px; display: flex; flex-direction: column; align-items: center; gap: 16px; }
.qr-box { width: 220px; height: 220px; display: flex; align-items: center; justify-content: center; }
.qr-placeholder { width: 100%; padding: 0 12px; text-align: center; color: #909399; font-size: 14px; line-height: 1.6; }
.qr-img { width: 200px; height: 200px; }
.qr-tip { font-size: 14px; color: #606266; text-align: center; }
.price { color: #ef4444; font-weight: 800; }
.zero-amount-confirm { text-align: center; margin-top: 16px; }
.zero-tip { color: #67c23a; font-size: 14px; margin-bottom: 12px; }
/* 购买成功弹框样式 */
.success-dialog {
  ::v-deep .el-dialog {
    border-radius: 20px;
    background: #fff;
    box-shadow: 0 10px 30px rgba(0,0,0,0.1);
    overflow: visible;
  }
  ::v-deep .el-dialog__header { display: none; }
  ::v-deep .el-dialog__body { padding: 40px 30px 30px; }
}

.success-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.success-icon-wrap {
  margin-bottom: 25px;
  position: relative;
  width: 180px;
  height: auto;
}

.success-main-img {
  width: 100%;
  height: auto;
  display: block;
}

.success-check-icon {
  position: absolute;
  bottom: -10px;
  right: -10px;
  width: 56px;
  height: 56px;
  filter: drop-shadow(0 4px 8px rgba(0,0,0,0.15));
}

/* Text & Button */
.success-text {
  margin-bottom: 30px;
  
  .title {
    font-size: 24px;
    font-weight: bold;
    color: #4034eb;
    margin-bottom: 10px;
  }
  
  .desc {
    font-size: 14px;
    color: #999;
  }
}

.confirm-btn {
  background-color: #4034eb;
  border-color: #4034eb;
  width: 140px;
  height: 40px;
  border-radius: 20px;
  font-size: 16px;
  box-shadow: 0 4px 12px rgba(64, 52, 235, 0.3);
  
  &:hover {
    background-color: #554af0;
    border-color: #554af0;
  }
}
</style>
